module.exports = __webpack_public_path__ + "img/img13.9cce0780.png";